<div class="dropdown-wrapper">
    <ham-button
        #companyFilterButtonWrapper
        class="company-filter-button"
        size="lg"
        [variant]="filterIsActive ? 'transparent' : 'white'"
        [outline]="true"
        rightIcon="assets/hamIcons/chevron-down.svg"
        (click)="openFlyout(companyFilterButtonWrapper)"
    >
        <span class="filter-number" *ngIf="filterIsActive"> {{ selectedCompanyIds?.length }} </span>
        {{ labelKey | i18next }}
    </ham-button>
</div>

<div class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-company-options-content">
        <ham-filter
            class="search-bar-companies"
            [placeholder]="'aumico_projects_overview_search_projects' | i18next"
            [hasFilterButton]="false"
            (filter)="onSearchFilterChange($event)"
        ></ham-filter>
        <div *ngFor="let company of companies">
            <label class="custom-checkbox company-option">
                <input
                    type="checkbox"
                    [checked]="selectedCompanyIds?.includes(company.id)"
                    (change)="onCompanySelection(company.id, $event.target.checked)"
                />
                <label (click)="$event.stopPropagation(); toggleCompanySelection(company.id)">
                    {{ company.name }}
                </label>
            </label>
        </div>
    </div>
    <div class="filter-actions">
        <ham-button variant="teal" size="sm" (click)="applyFilter()">{{
            'aumico_pm_tasks_apply_filter' | i18next
        }}</ham-button>
        <ham-button variant="white" size="sm" (click)="clearFilter()">{{
            'aumico_pm_tasks_clear_filter' | i18next
        }}</ham-button>
    </div>
</div>
